import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.University;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "University.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "University.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "University.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/UniversityGame/scenes/IntroductionScene.ts